import moment from 'moment';

export const FLOW_OPTIONS = [
    { value: 'installations', label: 'dashboard:installations' },
    { value: 'maintenance', label: 'dashboard:maintenance' },
    { value: 'uninstallations', label: 'dashboard:uninstallations' }
];

export const PERIOD_OPTIONS = [
    { value: 'week', label: 'dashboard:this_week' },
    { value: 'month', label: 'dashboard:this_month' },
    { value: 'last30', label: 'dashboard:last_30_days' }
];

export const defaultPeriod = 'last30';

export const getPeriodRange = (period = defaultPeriod) => {
    const to = moment().endOf('day');
    let from;

    switch (period) {
        case 'week':
            from = moment().startOf('week');
            break;
        case 'month':
            from = moment().startOf('month');
            break;
        case 'last30':
        default:
            from = moment().subtract(30, 'days').startOf('day');
            break;
    }

    return { from: from.toISOString(), to: to.toISOString() };
};

export const CATEGORY_TONE = {
    todo: 'blue',
    inprogress: 'amber',
    done: 'green'
};

export const toneByCategory = category => CATEGORY_TONE[category] || 'grey';

export const STATUS_TONE = {
    pending: 'red',
    verification: 'orange',
    coordination: 'amber',
    scheduled: 'blue',
    installed: 'green',
    validated: 'purple',
    finished: 'darkgreen',
    accomplished: 'green',
    failed: 'red',
    reschedule: 'amber',
    canceled: 'grey'
};

export const toneByStatus = statusName => STATUS_TONE[(statusName || '').toLowerCase()] || 'grey';
